import { ROUTE_USERS, ROUTE_OVERVIEW, ROUTE_STREAMING_ADVICE } from './routes';

const env = import.meta.env.VITE_ENV;
export const appVersion = import.meta.env.PACKAGE_VERSION;

export const isDevEnv = env === 'local' || env === 'develop';
export const isProdEnv = env === 'production';
export const adminMainRoute = ROUTE_USERS;
export const partnerAdminMainRoute = ROUTE_OVERVIEW;
export const csrAgentMainRoute = ROUTE_STREAMING_ADVICE;
export const DEFAULT_WP_ASSETS_SLUG = 'partner-assets';

export const getPartnerAssetsRoute = (partner = {}) => {
  const slug = partner?.settings?.wp_assets_slug || DEFAULT_WP_ASSETS_SLUG;

  return `/pages/${slug}`;
};

export const csrViewOnlyMainRoute = getPartnerAssetsRoute();

export default { isDevEnv, isProdEnv, appVersion };
